import { Component, OnInit, Input, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { ShelfPouchDb } from '../../shelf.pouchdb.service';
import { MycontentComponent } from '../../mycontent/mycontent.component';
import { bookCategories, bookCategoeyEnums } from '../../../shared/models/shelfEnums';
import { Constants } from '../../../shared/models/constants';
import { GoogleService } from '../../../shared/Google.service';
import { IS_ElectronService } from '../../../shared/IS_Electron.service';
import * as _ from "lodash";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ConformationDialogComponent } from '../ConformationDialog/ConformationDialog.component'

@Component({
  selector: 'app-createdBookInfo',
  templateUrl: './createdBookInfo.component.html',
  styleUrls: ['./createdBookInfo.component.css']
})
export class CreatedBookInfoComponent implements OnInit {

  @Input() data: any;
  bookDetails;
  selectedTab = undefined;
  listOfElememts;
  foldersToMove;
  infoElements = [];
  bookCategoeyEnums;
  bookCategoryTypes;
  myComponent;
  templates;
  isThumbChanging = false;
  bookTemplates;
  selectedThemeInd;
  bookInfoData = [];
  cteatedMytemplates;
  selectedMyTempInd = undefined;
  displayShelfChildsFor;
  shelfName;
  compId = false;
  shelfDataSubscription
  constructor(public dialog: MatDialog,private pouchservice: ShelfPouchDb, public GoogleService: GoogleService, private cdr: ChangeDetectorRef, private ElectronService: IS_ElectronService) { }
  @ViewChild('selectImg', { read: ElementRef }) public selectImg: ElementRef;

  bookFooterIcon = [{name:"Export",icon:'icon-Book-Export'}, {name:'Move',icon:"icon-Move-to-Folder"}, {name:"Upload",icon:"icon-Cloud-Upload"}, {name:"Delete",icon:"icon-Delete"}];
  ngOnInit() {
var self = this;
    this.bookDetails = this.data.popupProps.curComp.selBookDetals;
    // this.pouchservice.getShelfData(this, 0);
    // this.pouchservice.alternateGetShelfData(this, 0);
    this.myComponent = MycontentComponent;
    this.bookCategoeyEnums = bookCategoeyEnums;
    this.bookCategoryTypes = bookCategories;
    if(!this.ElectronService.IS_ELECTRON){
      this.templates = Constants.getTemplates();
      this.bookTemplates = Constants.getBookTemplatesArr();
    }
    else{
      this.templates = Constants.getElectronTemplates();
      this.bookTemplates = Constants.getElectronBookTemplatesArr();
    }
    if (this.bookDetails.templateId) {
      this.selectedThemeInd  = _.findIndex(this.bookTemplates, function (o:any) { return o.ID == self.bookDetails.templateId; });
    }

    this.bookInfoData = [{ 'key': 'Name', 'value': this.bookDetails.title }, { 'key': 'Author', 'value': this.bookDetails.author }];

    this.pouchservice.isMythemesDocAvailable(this);
    this.shelfName = this.data.popupProps.curComp.bookInfoShelfId;
    let id = Constants.USER+".04.Favourites"
    if(this.shelfName == id){
      this.compId = true;
    }

    this.shelfDataSubscription = this.pouchservice.interaction.subscribe(data => {
      self.updateListOfShlefs(data);
  })
    
  }

  ngOnDestroy(){
    
        if(this.shelfDataSubscription){
          this.shelfDataSubscription.unsubscribe();
        }
        
        }

  switchTabs(ind, ev) {
    ev.stopPropagation();
    this.selectedTab = ind;
    if (ind == 3 && this.shelfName != 'recent' && this.shelfName != 'Favourites') {
  this.data.popupProps.showPopup = false;
  var self = this;
      let dialogRef = this.dialog.open(ConformationDialogComponent, {
        width: '315px',
        disableClose: false
      });
  
      dialogRef.afterClosed().subscribe(result => {
          if(result){ 
            document.getElementsByClassName('showApploader')[0].classList.add('hideApploader');
            if(self.ElectronService.IS_ELECTRON){
              var deleteBookPath = self.ElectronService.USER_PATH+'/'+self.bookDetails.bId;
              self.ElectronService.deleteFolder(deleteBookPath);
            }
            self.pouchservice.deleteBookFromShelf(self.data.popupProps.curComp.selBookDetals, self.shelfName);
          }
      })
    }
    
    
    if (ind == 0) {

      this.data.popupProps.curComp.manageExportPopup(this.bookDetails);
      this.data.popupProps.showPopup = false;

    }
  }

  updateListOfShlefs(data) {
    this.infoElements = _.filter(data, function (filter) { return filter.parentId == undefined || filter.parentId == "" })
  }

  moveBookTo(ev, obj, ind) {

    var shelf = this.pouchservice.getShelfById(this.shelfName);

    this.data.popupProps.showPopup = false;
    ev.dragData = {
      book: this.bookDetails,
      draggingFrom: shelf.title,
      draggingFromId:shelf._id
    };
    parent.window.document['mycompthis'].onItemDrop(ev, obj, ind, true);
  }

  makeChildrenVisibleFlase(foldersToMove) {
    for (var i = 0; i < foldersToMove.length; i++) {
      foldersToMove[i].isChildrenShow = false;
      if (foldersToMove[i].subFolder && foldersToMove[i].subFolder.length) {
        this.makeChildrenVisibleFlase(foldersToMove[i].subFolder);
      }
    }
  }


  changeCoverPage(ev) {
    ev.stopPropagation();
    var bookType = this.bookCategoryTypes[this.bookCategoeyEnums[this.bookDetails.bookType]];
    if (bookType == 'EBE') {
      this.isThumbChanging = true;
    }
    else if (bookType == 'ELE') {
      this.selectImg.nativeElement.click();
    }
    else {
      return;
    }
  }


  readURL(fileInput) {

    if (fileInput.target.files && fileInput.target.files[0]) {
      const reader = new FileReader();
      reader.onload = ((e) => {
        this.bookDetails.coverPage = e.target['result'];
        if (this.ElectronService.IS_ELECTRON) {         
          this.ElectronService.insertFileintoMediaFolder(fileInput.target.files[0],this);
        }else{
          this.GoogleService.insertFileintofloder(fileInput.target.files[0], fileInput.target.files, localStorage.currentDriveMediaId, false, this);
        }
       
      });
      reader.readAsDataURL(fileInput.target.files[0]);

    }
  }

  imageAddedIntoDrive(file) {    
    if (this.ElectronService.IS_ELECTRON) {
      this.bookDetails.coverPage = file;
    }
    else{
      this.bookDetails.coverPage = file.thumbnailLink;
    }
    

  }

  updateBookNameAndAuthour() {
    this.bookDetails.title = this.bookInfoData[0].value;
    this.bookDetails.author = this.bookInfoData[1].value;

  }




  showChildrensList(ev, obj) {
    var self = this;
    ev.stopPropagation();
    if (obj.isChildrenShow) {
      obj.isChildrenShow = false;
    } else {
      this.displayShelfChildsFor = obj;
      this.pouchservice.getShelfChildren(obj).then(function(res){
        self.updateShelfChildren(res)
      })
    }

  }

  updateShelfChildren(childs) {
    this.displayShelfChildsFor.childrenArr = childs;
    this.displayShelfChildsFor.isChildrenShow = true;
  }

  updateSelectedTheme(ind, theme, ev) {
    this.bookDetails.coverPage = "";
    this.bookDetails.templateId = theme;
    this.selectedThemeInd = ind;
    this.bookDetails.isCustomTemplate = false;
    // this.cdr.detectChanges();
  }

  cancelSelectedTheme(ind, theme, ev) {
    ev.stopPropagation();
    this.selectedThemeInd = undefined;

  }

  addMyTemplateCoverPage(book) {
    var index = _.findIndex(this.cteatedMytemplates, function (o: any) { return o._id == book.templateId; });
    if (index > -1) {
      return this.cteatedMytemplates[index].cover.thumbUrl;
    }
  }

  updateMyTemplateTheme(ind) {
    this.bookDetails.coverPage = '';
    this.bookDetails.templateId = this.cteatedMytemplates[ind]._id;
    this.bookDetails.isCustomTemplate = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/shelf/popups/createdBookInfo/createdBookInfo.component.ts